import "./jp-city-code"

const CAREERS_LIMIT = 5;

export function toggleAddBtnCareer() {
  const careerLength = $('#new_form_job_entry_form').find('.nested-fields').length;
  const $career = $('#js-add_career');
  if (careerLength >= CAREERS_LIMIT) {
    $career.hide();
  } else {
    $career.show();
  }
};

$(function(){
  const START_YEAR = 1960;
  const END_YEAR = new Date().getFullYear();

  const $jobEntryBirthdayYear = $('#form_job_entry_form_birthday_on_1i');
  const $jobEntryBirthdayMonth = $('#form_job_entry_form_birthday_on_2i');
  const $jobEntryBirthDay = $('#form_job_entry_form_birthday_on_3i');

  const init = () => {
    $jobEntryBirthDay.empty();
    const year = $jobEntryBirthdayYear.val();
    const month = $jobEntryBirthdayMonth.val();
    const lastDay = getLastDay(year, month);
    setDay(lastDay);
    setCareersOption();
  }
  const getLastDay = (year, month) => {
    return new Date(year, month, 0).getDate();
  }

  const setCareersOption = lastDay => {
    const fragment = document.createDocumentFragment();
    for (let i = START_YEAR; i <= END_YEAR; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      fragment.appendChild(option);
    }

    $('.js-entry-input-careers-enrollment_start_year_at').append(fragment.cloneNode(true));
    $('.js-entry-input-careers-enrollment_end_year_at').append(fragment.cloneNode(true));
  }

  const setDay = lastDay => {
    const fragment = document.createDocumentFragment();
    for (let i = 0; i <= lastDay; i++) {
      const option = document.createElement('option');
      if(i === 0) {
        option.value = '';
        option.textContent = '----';
      } else {
        option.value = i;
        option.textContent = i;
      }
      fragment.appendChild(option);
    }
    $jobEntryBirthDay.append(fragment);
  }

  init();

  $('.js-add_fields').on('click', (e) => {
    const template = $('.careers-template').find('.nested-fields').clone();
    $(e.target).parent().before(template);

    toggleAddBtnCareer();
  });

  [$jobEntryBirthdayYear, $jobEntryBirthdayMonth].map(element => {
    $(element).on('change', e => {
      $jobEntryBirthDay.empty();
      const year = $jobEntryBirthdayYear.val();
      const month = $jobEntryBirthdayMonth.val();
      const lastDay = getLastDay(year, month);
      setDay(lastDay);
    })
  });

  const $jsSubmit = $('.js-entry-submit');
  const $jsConfirmBtn = $('.btn__confirm');

  $jsConfirmBtn.on('click', function(e){
    e.preventDefault();
  });

  $jsSubmit.on('click', function(e){
    e.preventDefault();
    $('#new_form_job_entry_form').off('submit').submit();
  });
});
